<script lang="ts" setup>
const props = withDefaults(defineProps<{
    title?: string
}>(), {
    title: `Your account has been suspended`,
})
</script>

<template>
    <div class="restricted">
        <h1>{{ props.title }}</h1>
        <p>
            <slot>
                Please contact <NuxtLink to="/customer-support">
                    customer support
                </NuxtLink> if you have any questions.
            </slot>
        </p>
    </div>
</template>

<style scoped lang="scss">
.restricted {
    min-height: calc(100vh - 170px);
    @media (min-width: $screen-md) {
        min-height: 50vh;
        width: 66.66667%;
    }
    @media (min-width: $screen-lg) {
        width: 75%;
    }
    h1 {
        font-weight: 700;
        line-height: 1;
        margin: 10px 0 30px;
    }
}
</style>
